"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.productVariantsMapper = function (item) { return ({
    items: item.variants.map(function (variantData) { return ({
        id: variantData.id,
        choices: variantData.choices,
        variant: variantData.variant
            ? {
                currency: variantData.variant.priceData.currency,
                price: variantData.variant.priceData.price,
                discountedPrice: variantData.variant.priceData.discountedPrice,
                formattedPrice: variantData.variant.priceData.formatted.price,
                formattedDiscountedPrice: variantData.variant.priceData.formatted.price,
                weight: variantData.variant.weight,
                sku: variantData.variant.sku,
                visible: variantData.variant.visible,
            }
            : undefined,
    }); }),
    length: item.metadata ? item.metadata.items : undefined,
    totalCount: item.totalResults,
}); };
exports.productVariantsParamMapper = function (item) { return ({
    choices: item.choices,
    variantIds: item.variantIds,
    paging: item.paging
        ? {
            limit: item.paging.limit,
            offset: item.paging.skip,
        }
        : undefined,
}); };
exports.productVariantsUpdatedMapper = function (item) {
    return {
        productId: item.productId,
        variants: item.variants.map(function (variant) { return ({
            variantId: variant.variantId,
            choices: variant.choices,
            updatedFields: variant.changedFields,
        }); }),
    };
};
//# sourceMappingURL=productVariants.mapper.js.map